import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { LocationService } from '../proxy/planning/controllers/location.service';
import { CountryService } from '@planning/proxy/planning/controllers/country.service';

FieldBuilder.setNamespace('Planning');

export const DEPARTMENT_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Department.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.Department.Code')
    .minLength(1)
    .maxLength(10)
    .build(),
  FieldBuilder
    .foreignKey('countryId', 'Entity.Country', CountryService)
    .required()
    .displayFromNested('country.name')
    .sortBy('country.name')
    .build(),
  FieldBuilder
    .foreignKey('locationId', 'Entity.Location', LocationService)
    .required()
    .displayFromNested('location.name')
    .sortBy('location.name')
    .hideInChildForms()
    .build(),
];

export const DEPARTMENT_CONFIG = {
  entityName: 'Department',
  localizationKey: 'Planning::Entity.Department',
  fields: DEPARTMENT_FIELDS,
  permission: 'PlanningGeography.Departments',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Geography + MENU_NAME_SUFFIX,
};
